import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { NotifierService } from 'angular-notifier';
import { Visit } from 'src/app/admin/models/visit.model';
import { VisitService } from 'src/app/admin/services/visit.service';

@Component({
  selector: 'app-view-qr-code',
  templateUrl: './view-qr-code.component.html',
  styleUrls: ['./view-qr-code.component.scss'],
})
export class ViewQrCodeComponent implements OnInit {
  @Input() code: string | any;
  visits = Visit;
  errMsg = '';

  constructor(private modalController: ModalController, private visitService: VisitService, private notifierService: NotifierService) { }

  ngOnInit() {
    this.getQrCode();
  }

  getQrCode() {
    this.visitService.getVisitQrCode(this.code).subscribe(
      (res: any) => {
        this.visits = res;
      }, (err) => {
        this.errMsg = 'Nije moguće pronaći posetu.';
        console.error(err);
      });
  }

  printQrCode() {
    this.visitService.printQrCode(this.code) .subscribe((data: ArrayBuffer) => {
      const blob = new Blob([data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = url;
      document.body.appendChild(iframe);
      iframe.contentWindow?.print();
      window.URL.revokeObjectURL(url);
      }, 
      err => {
        console.log(err); 
        this.notifierService.show({
          message: '' + JSON.stringify(err.error?.title || "Greška bez naslova"),
          type: 'warning',
        });
        console.error(err);
      }
    );
    this.dismissModal();
  }
  
  dismissModal() {
    this.modalController.dismiss();
  }
}
